// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1o1A8","cell":"ColumnAccessor_cell__6Wr9u","firstCellAccent":"ColumnAccessor_firstCellAccent__2dOcf"};